import m from 'mithril'
import stream from 'mithril/stream'
import classNames from 'classnames'
import {
    Search
} from '../models'
import {
    TextBox,
    RangeSilder
} from '../components'
import RangeSlider from '../components/form/range-slider'
import isMobile from '../lib/detect-mobile'

class SearchFormMap {
    constructor() {
        var i = 0
        this.show = false
        this.search = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }
        this.keyword = ""
        this.chosen_distrcts = []
        this.chosen_categories = []
        this.chosen_houseStyles = []
        this.chosen_houseTypes = []
        this.chosen_pains = []
        this.chosen_conditions = []

        this.search_item = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }

        this.min = stream(0)
        this.max = stream(50000)

        Search.fetchMap().then((responsive) => {
            this.search = responsive
            this.search.districts.map((district) => {
                this.chosen_distrcts.push(district.id)
            })
            this.search.categories.map((category) => {
                this.chosen_categories.push(category.id)
            })
            this.search.houseStyles.map((houseStyle) => {
                this.chosen_houseStyles.push(houseStyle.id)
            })
            this.search.houseTypes.map((houseType) => {
                this.chosen_houseTypes.push(houseType.id)
            })
            this.search.pains.map((pain) => {
                this.chosen_pains.push(pain.id)
            })
        })

        this.item = []
        for (i = 0; i < 10; i++) {
            this.item[i] = []
        }



    }

    view(vnode) {

        return m("form[id='search_form'][method='post']",
            m("input[id='json_value']", {
                name: 'search',
                type: 'hidden',
                value: JSON.stringify(this.search_item),
            }),
            m("input[id='result']", {
                name: 'result',
                type: 'hidden',
                value: "",
            }),
            [
                m(".dropdown",
                    [
                        m("a.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[aria-expanded='false'][aria-haspopup='true'][data-toggle='dropdown'][href='#'][id='dropdownMenuButton']",
                            "房屋選項"
                        ),
                        m(".dropdown-menu[aria-labelledby='dropdownMenuButton']", {
                            style: {
                                "width": "700px"
                            }
                        },
                            m(".row.no-gutters.py-3",
                                [
                                    m(".col.pl-20",
                                        [
                                            m(".h5.pt-20",
                                                "依物件類型"
                                            ),
                                            m("ul.other-features",
                                                m("li",
                                                    [
                                                        m("input[id='ol-1'][type='checkbox']", {
                                                            checked: this.chosen_categories.length == this.search.categories.length,
                                                            onclick: (e) => {
                                                                if (this.chosen_categories.length == this.search.categories.length) {
                                                                    this.chosen_categories = []
                                                                } else {
                                                                    this.chosen_categories = []
                                                                    this.search.categories.map(item => {
                                                                        this.chosen_categories.push(item.id)

                                                                    })
                                                                }
                                                            }
                                                        }),
                                                        m("label.font-weight-bold[for='ol-1']",
                                                            "不限"
                                                        )
                                                    ]
                                                )
                                            ),
                                            m(".h6.pt-20",
                                                "社會住宅"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    this.search.categories.map((category) => {
                                                        if (category.item == 1) {
                                                            return m("li",
                                                                [
                                                                    m(`input[id='al-${category.id}'][type='checkbox']`, {
                                                                        checked: this.chosen_categories.indexOf(category.id) > -1,
                                                                        onclick: (e) => {
                                                                            if (this.chosen_categories.indexOf(category.id) > -1) {
                                                                                this.chosen_categories.splice(this.chosen_categories.indexOf(category.id), 1)
                                                                            } else {
                                                                                this.chosen_categories.push(category.id)
                                                                            }
                                                                        }
                                                                    }),
                                                                    m(`label[for='al-${category.id}']`,
                                                                        category.name
                                                                    )
                                                                ]
                                                            )
                                                        }
                                                    })
                                                ]
                                            ),
                                            m(".h6.pt-20",
                                                "一般出租住宅"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    this.search.categories.map((category) => {
                                                        if (category.item == 2) {
                                                            return m("li",
                                                                [
                                                                    m(`input[id='al-${category.id}'][type='checkbox']`, {
                                                                        checked: this.chosen_categories.indexOf(category.id) > -1,
                                                                        onclick: (e) => {
                                                                            if (this.chosen_categories.indexOf(category.id) > -1) {
                                                                                this.chosen_categories.splice(this.chosen_categories.indexOf(category.id), 1)
                                                                            } else {
                                                                                this.chosen_categories.push(category.id)
                                                                            }
                                                                        }
                                                                    }),
                                                                    m(`label[for='al-${category.id}']`,
                                                                        category.name
                                                                    )
                                                                ]
                                                            )
                                                        }
                                                    })
                                                ]
                                            )
                                        ]
                                    ),
                                    m(".col",
                                        [
                                            m(".h6.pt-20",
                                                "依房數"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    m("li",
                                                        [
                                                            m("input[id='bl-11'][type='checkbox']", {
                                                                checked: this.chosen_houseStyles.length == this.search.houseStyles.length,
                                                                onclick: (e) => {
                                                                    if (this.chosen_houseStyles.length == this.search.houseStyles.length) {
                                                                        this.chosen_houseStyles = []
                                                                    } else {
                                                                        this.chosen_houseStyles = []
                                                                        this.search.houseStyles.map(item => {
                                                                            this.chosen_houseStyles.push(item.id)

                                                                        })
                                                                    }
                                                                }
                                                            }),
                                                            m("label.font-weight-bold[for='bl-11']",
                                                                "不限"
                                                            )
                                                        ]
                                                    ),
                                                    this.search.houseStyles.map((style) => {
                                                        return m("li",
                                                            [
                                                                m(`input[id='bl-${style.id}'][type='checkbox']`, {
                                                                    checked: this.chosen_houseStyles.indexOf(style.id) > -1,
                                                                    onclick: (e) => {
                                                                        if (this.chosen_houseStyles.indexOf(style.id) > -1) {
                                                                            this.chosen_houseStyles.splice(this.chosen_houseStyles.indexOf(style.id), 1)
                                                                        } else {
                                                                            this.chosen_houseStyles.push(style.id)
                                                                        }
                                                                    }
                                                                }),
                                                                m(`label[for='bl-${style.id}']`,
                                                                    style.name
                                                                )
                                                            ]
                                                        )
                                                    })
                                                ]
                                            )
                                        ]
                                    ),
                                    m(".col",
                                        [
                                            m(".h6.pt-20",
                                                "依房屋類型"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    m("li",
                                                        [
                                                            m("input[id='ol-14'][type='checkbox']", {
                                                                checked: this.chosen_houseTypes.length == this.search.houseTypes.length,
                                                                onclick: (e) => {
                                                                    if (this.chosen_houseTypes.length == this.search.houseTypes.length) {
                                                                        this.chosen_houseTypes = []
                                                                    } else {
                                                                        this.chosen_houseTypes = []
                                                                        this.search.houseTypes.map(item => {
                                                                            this.chosen_houseTypes.push(item.id)

                                                                        })
                                                                    }
                                                                }
                                                            }),
                                                            m("label.font-weight-bold[for='ol-14']",
                                                                "不限"
                                                            )
                                                        ]
                                                    ),
                                                    this.search.houseTypes.map((type) => {
                                                        return m("li",
                                                            [
                                                                m(`input[id='cl-${type.id}'][type='checkbox']`, {
                                                                    checked: this.chosen_houseTypes.indexOf(type.id) > -1,
                                                                    onclick: (e) => {
                                                                        if (this.chosen_houseTypes.indexOf(type.id) > -1) {
                                                                            this.chosen_houseTypes.splice(this.chosen_houseTypes.indexOf(type.id), 1)
                                                                        } else {
                                                                            this.chosen_houseTypes.push(type.id)
                                                                        }
                                                                    }
                                                                }),
                                                                m(`label[for='cl-${type.id}']`,
                                                                    type.name
                                                                )
                                                            ]
                                                        )
                                                    })
                                                ]
                                            )
                                        ]
                                    ),
                                    m(".col",
                                        [
                                            m(".h6.pt-20",
                                                "依坪數"
                                            ),
                                            m("ul.other-features",
                                                [
                                                    m("li",
                                                        [
                                                            m("input[id='ol-21'][type='checkbox']", {
                                                                checked: this.chosen_pains.length == this.search.pains.length,
                                                                onclick: (e) => {
                                                                    if (this.chosen_pains.length == this.search.pains.length) {
                                                                        this.chosen_pains = []
                                                                    } else {
                                                                        this.chosen_pains = []
                                                                        this.search.pains.map(item => {
                                                                            this.chosen_pains.push(item.id)

                                                                        })
                                                                    }
                                                                }
                                                            }),
                                                            m("label.font-weight-bold[for='ol-21']",
                                                                "不限"
                                                            )
                                                        ]
                                                    ),
                                                    this.search.pains.map((pain) => {
                                                        return m("li",
                                                            [
                                                                m(`input[id='dl-${pain.id}'][type='checkbox']`, {
                                                                    checked: this.chosen_pains.indexOf(pain.id) > -1,
                                                                    onclick: (e) => {
                                                                        if (this.chosen_pains.indexOf(pain.id) > -1) {
                                                                            this.chosen_pains.splice(this.chosen_pains.indexOf(pain.id), 1)
                                                                        } else {
                                                                            this.chosen_pains.push(pain.id)
                                                                        }
                                                                    }
                                                                }),
                                                                m(`label[for='dl-${pain.id}']`,
                                                                    pain.name
                                                                )
                                                            ]
                                                        )
                                                    })
                                                ]
                                            )
                                        ]
                                    )
                                ]
                            )
                        )
                    ]
                ),
                m(".dropdown",
                    [
                        m("a.btn.btn-outline-secondary.dropdown-toggle.btn-block.template-select[aria-expanded='false'][aria-haspopup='true'][data-toggle='dropdown'][href='#'][id='dropdownMenuButton']",
                            "其他條件"
                        ),
                        m(".dropdown-menu[aria-labelledby='dropdownMenuButton']",
                            [
                                m(".h6.pt-20.pl-20",
                                    "其他條件"
                                ),
                                m("ul.other-features.pl-20.pb-15", {
                                    style: {
                                        width: '540px'
                                    }
                                },
                                    [
                                        this.search.conditions.map((condition) => {
                                            return [m("li.mr-1", {
                                                style: {
                                                    "width": "30%"
                                                }
                                            },
                                                [
                                                    m(`input[id='el-${condition.id}'][type='checkbox']`, {
                                                        checked: this.chosen_conditions.indexOf(condition.id) > -1,
                                                        onclick: (e) => {
                                                            if (this.chosen_conditions.indexOf(condition.id) > -1) {
                                                                this.chosen_conditions.splice(this.chosen_conditions.indexOf(condition.id), 1)
                                                            } else {
                                                                this.chosen_conditions.push(condition.id)
                                                            }
                                                        }
                                                    }),
                                                    m(`label[for='el-${condition.id}']`,
                                                        condition.name
                                                    )
                                                ]
                                            )]
                                        })
                                    ]
                                )
                            ]
                        )
                    ]
                ),
                m(".pl-40 pr-40",
                    m(RangeSlider, {
                        min: this.min,
                        max: this.max,
                        start: this.min,
                        end: this.max,
                    })
                ),
                m("div",
                    m(TextBox, {
                        oninput: (e) => {
                            this.keyword = e.target.value
                        },
                        class: 'mt-0',
                        value: this.keyword,
                        type: 'text',
                        placeholder: '關鍵字搜尋(社區、路名)'
                    }),
                ),
                m(".text-right.text-lg-center.pb-15", {
                    style: {
                        "margin-top": "-15px"
                    }
                },
                    m("button.rounded-pill.p-0[id='serach_button']",
                        m("a.w-100.h-100.py-2", {
                            onclick: (e) => {
                                e.preventDefault()
                                this.search_item = {
                                    categories: [],
                                    districts: [],
                                    houseStyles: [],
                                    houseTypes: [],
                                    pains: [],
                                    conditions: [],
                                    keyword: this.keyword,
                                    range: []
                                }
                                this.chosen_distrcts.map((district) => {
                                    this.search_item.districts.push({
                                        id: district
                                    })
                                })
                                this.chosen_categories.map((categoriy) => {
                                    this.search_item.categories.push({
                                        id: categoriy
                                    })
                                })
                                this.chosen_houseStyles.map((houseStyle) => {
                                    this.search_item.houseStyles.push({
                                        id: houseStyle
                                    })
                                })
                                this.chosen_houseTypes.map((houseType) => {
                                    this.search_item.houseTypes.push({
                                        id: houseType
                                    })
                                })
                                this.chosen_pains.map((pain) => {
                                    this.search_item.pains.push({
                                        id: pain
                                    })
                                })
                                this.chosen_conditions.map((condition) => {
                                    this.search_item.conditions.push({
                                        id: condition
                                    })
                                })
                                this.search_item.range[0] = this.min()
                                this.search_item.range[1] = this.max()

                                $('#json_value').val(JSON.stringify(this.search_item))
                                $.post('/RentHouse/Map', {
                                    search: JSON.stringify(this.search_item)
                                }, function (result) {
                                    window.result = result
                                    $('#result').val(JSON.stringify(result)).trigger('change')
                                })

                            }
                        },
                            "搜尋",
                        ))

                )
            ]
        )

    }
}

class MobileSearchFormMap {
    constructor() {
        var i = 0
        this.show = false
        this.search = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }
        this.keyword = ""
        this.chosen_distrcts = []
        this.chosen_categories = []
        this.chosen_houseStyles = []
        this.chosen_houseTypes = []
        this.chosen_pains = []
        this.chosen_conditions = []

        this.search_item = {
            categories: [],
            districts: [],
            houseStyles: [],
            houseTypes: [],
            pains: [],
            conditions: [],
            keyword: "",
            range: []
        }

        Search.fetchMap().then((responsive) => {
            this.search = responsive
            this.search.districts.map((district) => {
                this.chosen_distrcts.push(district.id)
            })
            this.search.categories.map((category) => {
                this.chosen_categories.push(category.id)
            })
            this.search.houseStyles.map((houseStyle) => {
                this.chosen_houseStyles.push(houseStyle.id)
            })
            this.search.houseTypes.map((houseType) => {
                this.chosen_houseTypes.push(houseType.id)
            })
            this.search.pains.map((pain) => {
                this.chosen_pains.push(pain.id)
            })
        })

        this.item = []
        for (i = 0; i < 10; i++) {
            this.item[i] = []
        }



    }

    view(vnode) {

        return m("form[id='mobileSearch'][method='post']",
            m("input[id='json_value']", {
                name: 'search',
                type: 'hidden',
                value: JSON.stringify(this.search_item),
            }),
            m("input[id='result']", {
                name: 'result',
                type: 'hidden',
                value: "",
            }),
            [
                m('ul.collapsible.mt-0.z-depth-0', [
                    m('li.d-block.m-0.w-100', [
                        m('.collapsible-header.d-block.w-100.pt-15', [
                            m("i.material-icons.align-middle", "line_style"),
                            m("span.align-middle", "物件類型"),
                            m("i.material-icons.align-middle.ml-auto", "arrow_drop_down")
                        ]),
                        m('.collapsible-body.p-3', [
                            m('.ck-button.d-inline-flex',
                                m("label.mb-0.d-inline.pl-0",
                                    [
                                        m("input[type='checkbox'][value='0']", {
                                            checked: this.chosen_categories.length == this.search.categories.length,
                                            onclick: (e) => {
                                                if (this.chosen_categories.length == this.search.categories.length) {
                                                    this.chosen_categories = []
                                                } else {
                                                    this.chosen_categories = []
                                                    this.search.categories.map(item => {
                                                        this.chosen_categories.push(item.id)

                                                    })
                                                }
                                            }
                                        }),
                                        m("span.px-2", { style: { 'fontSize': '0.95rem' } },
                                            "不限"
                                        )
                                    ]
                                )
                            ),

                            this.search.categories.map((category) => {
                                return m(".ck-button.d-inline-flex",
                                    m("label.mb-0.d-inline.pl-0",
                                        [
                                            m(`input[type='checkbox'][value='${category.id}']`, {
                                                checked: this.chosen_categories.indexOf(category.id) > -1,
                                                onclick: (e) => {
                                                    if (this.chosen_categories.indexOf(category.id) > -1) {
                                                        this.chosen_categories.splice(this.chosen_categories.indexOf(category.id), 1)
                                                    } else {
                                                        this.chosen_categories.push(category.id)
                                                    }
                                                }
                                            }),
                                            m('span.px-2', { style: { 'fontSize': '0.95rem' } },
                                                category.name
                                            )
                                        ]
                                    ))
                            })

                        ])
                    ]),
                    m('li.d-block.m-0.w-100', [
                        m('.collapsible-header.d-block.w-100.pt-15', [
                            m("i.material-icons.align-middle", "border_clear"),
                            m("span.align-middle", "房數"),
                            m("i.material-icons.align-middle.ml-auto", "arrow_drop_down")
                        ]),
                        m('.collapsible-body.p-3', [
                            m('.ck-button.d-inline-flex',
                                m("label.mb-0.d-inline.pl-0", [
                                    m("input[type='checkbox'][value='0']", {
                                        checked: this.chosen_houseStyles.length == this.search.houseStyles.length,
                                        onclick: (e) => {
                                            if (this.chosen_houseStyles.length == this.search.houseStyles.length) {
                                                this.chosen_houseStyles = []
                                            } else {
                                                this.chosen_houseStyles = []
                                                this.search.houseStyles.map(item => {
                                                    this.chosen_houseStyles.push(item.id)

                                                })
                                            }
                                        }
                                    }),
                                    m("span.px-2", {
                                        style: {
                                            'fontSize': '0.95rem'
                                        }
                                    },
                                        "不限"
                                    )
                                ]
                                )
                            ),
                            this.search.houseStyles.map((style) => {
                                return m(".ck-button.d-inline-flex",
                                    m("label.mb-0.d-inline.pl-0",
                                        [
                                            m(`input[type='checkbox'][value='${style.id}']`, {
                                                checked: this.chosen_houseStyles.indexOf(style.id) > -1,
                                                onclick: (e) => {
                                                    if (this.chosen_houseStyles.indexOf(style.id) > -1) {
                                                        this.chosen_houseStyles.splice(this.chosen_houseStyles.indexOf(style.id), 1)
                                                    } else {
                                                        this.chosen_houseStyles.push(style.id)
                                                    }
                                                }
                                            }),
                                            m('span.px-2', {
                                                style: {
                                                    'fontSize': '0.95rem'
                                                }
                                            },
                                                style.name
                                            )
                                        ]
                                    ))
                            })
                        ])
                    ]),
                    m('li.d-block.m-0.w-100', [
                        m('.collapsible-header.d-block.w-100.pt-15', [
                            m("i.material-icons.align-middle", "format_list_bulleted"),
                            m("span.align-middle", "房屋類型"),
                            m("i.material-icons.align-middle.ml-auto", "arrow_drop_down")
                        ]),
                        m('.collapsible-body.p-3', [
                            m('.ck-button.d-inline-flex',
                                m("label.mb-0.d-inline.pl-0", [
                                    m("input[type='checkbox'][value='0']", {
                                        checked: this.chosen_houseTypes.length == this.search.houseTypes.length,
                                        onclick: (e) => {
                                            if (this.chosen_houseTypes.length == this.search.houseTypes.length) {
                                                this.chosen_houseTypes = []
                                            } else {
                                                this.chosen_houseTypes = []
                                                this.search.houseTypes.map(item => {
                                                    this.chosen_houseTypes.push(item.id)

                                                })
                                            }
                                        }
                                    }),
                                    m("span.px-2", {
                                        style: {
                                            'fontSize': '0.95rem'
                                        }
                                    },
                                        "不限"
                                    )
                                ])
                            ),
                            this.search.houseTypes.map((type) => {
                                return m(".ck-button.d-inline-flex",
                                    m("label.mb-0.d-inline.pl-0",
                                        [
                                            m(`input[type='checkbox'][value='${type.id}']`, {
                                                checked: this.chosen_houseTypes.indexOf(type.id) > -1,
                                                onclick: (e) => {
                                                    if (this.chosen_houseTypes.indexOf(type.id) > -1) {
                                                        this.chosen_houseTypes.splice(this.chosen_houseTypes.indexOf(type.id), 1)
                                                    } else {
                                                        this.chosen_houseTypes.push(type.id)
                                                    }
                                                }
                                            }),
                                            m('span.px-2', {
                                                style: {
                                                    'fontSize': '0.95rem'
                                                }
                                            },
                                                type.name
                                            )
                                        ]
                                    )
                                )
                            })
                        ])
                    ]),
                    m('li.d-block.m-0.w-100', [
                        m('.collapsible-header.d-block.w-100.pt-15', [
                            m("i.material-icons.align-middle", "dialpad"),
                            m("span.align-middle", "坪數"),
                            m("i.material-icons.align-middle.ml-auto", "arrow_drop_down")
                        ]),
                        m('.collapsible-body.p-3', [
                            m('.ck-button.d-inline-flex',
                                m("label.mb-0.d-inline.pl-0", [
                                    m("input[type='checkbox'][value='0']", {
                                        checked: this.chosen_pains.length == this.search.pains.length,
                                        onclick: (e) => {
                                            if (this.chosen_pains.length == this.search.pains.length) {
                                                this.chosen_pains = []
                                            } else {
                                                this.chosen_pains = []
                                                this.search.pains.map(item => {
                                                    this.chosen_pains.push(item.id)

                                                })
                                            }
                                        }
                                    }),
                                    m("span.px-2", {
                                        style: {
                                            'fontSize': '0.95rem'
                                        }
                                    },
                                        "不限"
                                    )
                                ])
                            ),
                            this.search.pains.map((pain) => {
                                return m(".ck-button.d-inline-flex",
                                    m("label.mb-0.d-inline.pl-0",
                                        [
                                            m(`input[type='checkbox'][value='${pain.id}']`, {
                                                checked: this.chosen_pains.indexOf(pain.id) > -1,
                                                onclick: (e) => {
                                                    if (this.chosen_pains.indexOf(pain.id) > -1) {
                                                        this.chosen_pains.splice(this.chosen_pains.indexOf(pain.id), 1)
                                                    } else {
                                                        this.chosen_pains.push(pain.id)
                                                    }
                                                }
                                            }),
                                            m('span.px-2', {
                                                style: {
                                                    'fontSize': '0.95rem'
                                                }
                                            },
                                                pain.name
                                            )
                                        ]
                                    )
                                )
                            })
                        ])
                    ]),
                    m('li.d-block.m-0.w-100', [
                        m('.collapsible-header.d-block.w-100.pt-15', [
                            m("i.material-icons.align-middle", "blur_on"),
                            m("span.align-middle", "其他條件"),
                            m("i.material-icons.align-middle.ml-auto", "arrow_drop_down")
                        ]),
                        m('.collapsible-body.p-3', [
                            this.search.conditions.map((condition) => {
                                return m(".ck-button.d-inline-flex",
                                    m("label.mb-0.d-inline.pl-0",
                                        [
                                            m(`input[type='checkbox'][value='${condition.id}']`, {
                                                checked: this.chosen_conditions.indexOf(condition.id) > -1,
                                                onclick: (e) => {
                                                    if (this.chosen_conditions.indexOf(condition.id) > -1) {
                                                        this.chosen_conditions.splice(this.chosen_conditions.indexOf(condition.id), 1)
                                                    } else {
                                                        this.chosen_conditions.push(condition.id)
                                                    }
                                                }
                                            }),
                                            m('span.px-2', {
                                                style: {
                                                    'fontSize': '0.95rem'
                                                }
                                            },
                                                condition.name
                                            )
                                        ]
                                    ))
                            })
                        ])
                    ]),
                ]),
                m('.d-flex.justify-content-center.mt-25.mb-25',
                    m('a.btn.btn-theme.w-50.rounded-pill.text-white', {
                        onclick: (e) => {
                            e.preventDefault()
                            this.search_item = {
                                categories: [],
                                districts: [],
                                houseStyles: [],
                                houseTypes: [],
                                pains: [],
                                conditions: [],
                                keyword: this.keyword,
                                range: []
                            }
                            this.chosen_distrcts.map((district) => {
                                this.search_item.districts.push({
                                    id: district
                                })
                            })
                            this.chosen_categories.map((categoriy) => {
                                this.search_item.categories.push({
                                    id: categoriy
                                })
                            })
                            this.chosen_houseStyles.map((houseStyle) => {
                                this.search_item.houseStyles.push({
                                    id: houseStyle
                                })
                            })
                            this.chosen_houseTypes.map((houseType) => {
                                this.search_item.houseTypes.push({
                                    id: houseType
                                })
                            })
                            this.chosen_pains.map((pain) => {
                                this.search_item.pains.push({
                                    id: pain
                                })
                            })
                            this.chosen_conditions.map((condition) => {
                                this.search_item.conditions.push({
                                    id: condition
                                })
                            })
                            this.search_item.range[0] = 0
                            this.search_item.range[1] = 50000

                            $('#json_value').val(JSON.stringify(this.search_item))
                            $.post('/RentHouse/Map', {
                                search: JSON.stringify(this.search_item)
                            }, function (result) {
                                window.result = result
                                $('#result').val(JSON.stringify(result)).trigger('change')
                            })
                            // $('.mobileSearchBar').css("transition", "all 0.5s");
                            $('.mobileSearchBar').css("width", "0%");
                            $('.mobileTop').addClass('d-none');
                            $('.mobileTop').removeClass('d-flex');
                            $('.mobileBottom').removeClass('d-none');
                            $('.mobileBottom').addClass('d-flex');

                        }
                    }, '搜尋')
                )
            ]
        )

    }
}
window.isMobile = isMobile()
export default (window.isMobile) ? MobileSearchFormMap : SearchFormMap